<div class="w-100 h-100 b-logo" fxLayout="column" fxLayoutAlign="center center">
    <div fxLayout="column" fxLayoutAlign="center center">
        <ui-kit-svg class="error-logo" [name]="errorIcon"></ui-kit-svg>
        <div class="h3-semi-bold mt-32 text-center pre-line">{{ errorTitle | translate }}</div>
        @if ((errorSubtitle | translate) !== errorSubtitle) {
            <div class="t2 mt-16 pre-line text-center">
                {{ errorSubtitle | translate }}
            </div>
        }
        @if (requestId) {
            <div class="t4 mt-16 c-primary-gray-600 pre-line text-center">
                {{ 'i18n_af_appErrorErrorCode' | translate: {code: requestId} }}
            </div>
        }
        @if (error === Error.NETWORK_CONNECTIVITY_ERROR) {
            <div class="mt-16">
                <ui-kit-button ngClass.mobile="w-100"
                               type="secondary"
                               [label]="'i18n_af_buttonRetry' | translate"
                               (clickListener)="retry()">
                </ui-kit-button>
            </div>
        }
    </div>
</div>
